import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/trust-pilot-extended.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const TrustPilotExtended = withSvgProps(Svg)
